import React from 'react';
import CustomDropdown from '../../../../components/CustomDropdown/CustomDropdown';
import { DATE_OPTIONS, JOB_OPTIONS, APPROVED_OPTIONS } from './constants';

interface FilterRowProps {
  dateFilter: string;
  jobFilter: string;
  approvedByFilter: string;
  onDateChange: (v: string) => void;
  onJobChange: (v: string) => void;
  onApprovedByChange: (v: string) => void;
}

export default function FilterRow({ dateFilter, jobFilter, approvedByFilter, onDateChange, onJobChange, onApprovedByChange }: FilterRowProps) {
  return (
    <div className="flex gap-3.5 pt-4 pb-4 md:gap-4">
      <div className="flex flex-col gap-1.5 min-w-[220px]">
        <div className="text-[11px] font-semibold text-ink3">Date changed</div>
        <CustomDropdown value={dateFilter} onChange={onDateChange} options={DATE_OPTIONS} />
      </div>
      <div className="flex flex-col gap-1.5 min-w-[220px]">
        <div className="text-[11px] font-semibold text-ink3">Job</div>
        <CustomDropdown value={jobFilter} onChange={onJobChange} options={JOB_OPTIONS} />
      </div>
      <div className="flex flex-col gap-1.5 min-w-[220px]">
        <div className="text-[11px] font-semibold text-ink3">Approved by</div>
        <CustomDropdown value={approvedByFilter} onChange={onApprovedByChange} options={APPROVED_OPTIONS} />
      </div>
    </div>
  );
}